<div class="features">
    <div class="active-plan-feature">
        <h4 class="feature-header">
            {{ featureTitle }}
        </h4>
        <div class="features-content">
            <div *ngFor="let feature of dataFeatures" class="plan-feature">
                <xm-media-image aria-hidden="true" [imageOptions]="generateFeatureIcon(feature.icon)"
                    class="plan-feature-icon"></xm-media-image>
                <div class="plan-feature-description">
                    <h4 class="plan-feature-header">{{ feature.header }}</h4>
                    <p class="plan-feature-subheader">{{ feature.subheader }}</p>
                </div>
            </div>
        </div>
    </div>
    <ng-content></ng-content>
</div>
